var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"d-book-submission-min-date"},[_vm._v(_vm._s(_vm.minDiscoveryLaunchDate.duration)+" "+_vm._s(_vm.minDiscoveryLaunchDate.type))])
}
var staticRenderFns = []

export { render, staticRenderFns }